import { render, staticRenderFns } from "./deleteCustomView.vue?vue&type=template&id=8d3c49ec&scoped=true&"
import script from "./deleteCustomView.vue?vue&type=script&lang=js&"
export * from "./deleteCustomView.vue?vue&type=script&lang=js&"
import style0 from "./deleteCustomView.vue?vue&type=style&index=0&id=8d3c49ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3c49ec",
  null
  
)

export default component.exports